import { useEffect } from "react";
import Cursor from "../components/site/Cursor";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import Statement from "../components/site/Statement";
import Showcase from "../components/site/Showcase";
import Pillars from "../components/site/Ecosystem";
import Services from "../components/site/Services";
import Partner from "../components/site/Partner";
import Audiences from "../components/site/Audiences";
import Testimonials from "../components/site/Testimonials";
import Manifesto from "../components/site/Manifesto";
import Footer from "../components/site/Footer";

export default function Landing() {
  useEffect(() => {
    document.title =
      "Credit Stone Digital — A private financial ecosystem for global investors";
  }, []);

  return (
    <main className="relative bg-[#0A0B0D] text-[#F4F2EC] grain min-h-screen">
      <Cursor />
      <Nav />
      <Hero />
      <Statement />
      <Showcase />
      <Pillars />
      <Services />
      <Partner />
      <Audiences />
      <Testimonials />
      <Manifesto />
      <Footer />
    </main>
  );
}
